import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
    user: null,
    user_sip: null,
    token: Cookies.get('token'),
    last_reload: null,
};

// getters
export const getters = {
    user: state => state.user,
    token: state => state.token,
    last_reload: state => state.last_reload,
    check: state => state.user !== null,
    sip_settings: state => {
        let data = {
            use: null,
            login: null,
            password: null,
            host: null,
            status: false,
            ws_port: null,
            ws_url: null,
            call_center_id: null,
            call_server_id: null,
        };
        // let user = context.getters['auth/user'];
        let user = state.user;
        let user_sip = state.user_sip;
        if (!user) return data;

        data.login = user_sip ? user_sip.login : null;
        data.password = user_sip ? user_sip.password : null;
        data.status = !!user.sip_status;

        let call_center = (user.call_centers && user.call_centers.length) ? user.call_centers[0] : null;
        if (call_center) {
            let call_server = call_center.call_server;
            data.host = call_server.host;
            data.ws_port = call_server.ws_port;
            data.ws_url = call_server.ws_url;
            data.call_center_id = call_center.id;
            data.call_server_id = call_server.id;
        }

        data.use = !!(user.sip_use && data.login && data.password && data.ws_url);

        return data;
    }
};

// mutations
export const mutations = {
    [types.SAVE_TOKEN](state, {token, remember}) {
        state.token = token;
        Cookies.set('token', token, {expires: remember ? 365 : null, Secure: true})
        window.Echo.options.auth.headers['Authorization'] = `Bearer ${token}`;
    },

    [types.FETCH_USER_SUCCESS](state, {user}) {
        state.user = user
        if (state.user_sip === null && user.sip_login && user.sip_password) {
            state.user_sip = {
                login: user.sip_login,
                password: user.sip_password,
            }
        }
    },

    [types.FETCH_USER_FAILURE](state) {
        state.token = null;
        Cookies.remove('token')
    },

    [types.ON_LOGOUT](state) {
        state.user = null;
        state.token = null;

        Cookies.remove('token')

        _.keys(Echo.connector.channels).forEach(function (channel_name) {
            Echo.leaveChannel(channel_name);
        });
    },

    [types.UPDATE_USER](state, {user}) {
        state.user = user
    },
    [types.USER_PUSH_ALLOWED_REQUESTS_IDS](state, id) {
        if (state.user && state.user.allowed_requests_ids) {
            state.user.allowed_requests_ids.push(parseInt(id));
        }
    },
    [types.USER_CHANGE_SIP_STATUS](state, status) {
        if (state.user) {
            state.user.sip_status = status;
        }
    },
    [types.CLEAR_USER_SIP](state) {
        state.user_sip = null;
    },
    [types.INIT_LAST_RELOAD](state) {
        state.last_reload = moment().unix();
    }
};

// actions
export const actions = {
    saveToken({commit, dispatch}, payload) {
        commit(types.SAVE_TOKEN, payload)
    },

    async fetchUser({state, commit}) {
        try {
            // Если сипа ещё нет то получаем вместе с сипом
            const {data} = await axios.get('/api/user' + (state.user_sip === null ? '?hold_sip' : '' ));

            commit(types.FETCH_USER_SUCCESS, {user: data})
        } catch (e) {
            commit(types.FETCH_USER_FAILURE)
        }
    },

    updateUser({commit}, payload) {
        commit(types.UPDATE_USER, payload)
    },

    async logout({commit}) {
        try {
            await axios.post('/api/logout')
        } catch (e) {
        }

        commit(types.ON_LOGOUT);
    },
    async onLogout({commit}) {
        commit(types.ON_LOGOUT);
    },

    async fetchOauthUrl(ctx, {provider}) {
        const {data} = await axios.post(`/api/oauth/${provider}`);

        return data.url
    },

    pushAllowedRequestsIds({commit}, id) {
        commit(types.USER_PUSH_ALLOWED_REQUESTS_IDS, id);
    },

    async changeSipStatus({commit}, status) {
        try {
            await axios.post('/api/user/change_sip_status', {status: status});
            commit(types.USER_CHANGE_SIP_STATUS, status)
        } catch (e) {

        }
    },
    initLastReload({commit}) {
        commit(types.INIT_LAST_RELOAD)
    },
    async confirmOnline({state, commit}) {
        if (!state.last_reload) {
            commit(types.INIT_LAST_RELOAD)
        }
        if (state.user !== null) {
            let call_center = (state.user.call_centers && state.user.call_centers.length) ? state.user.call_centers[0] : null;
            let user_sip = state.user_sip;
            await axios.put('/api/user/online', {
                call_server_id: call_center ? call_center.call_server_id : null,
                sip_login: user_sip !== null && user_sip.login ? user_sip.login : null,
                last_reload: state.last_reload,
            });
        }
    },
    async clearUserSip({commit}) {
        commit(types.CLEAR_USER_SIP);
    }
};
